<template>
  <div class='forgetPwd'>
      <div class="login_box">
        <div class="login_logo_box">
            <img class="logo" :src="logo" alt="">
            <p class="title">{{ title }}</p>
        </div>
        <p class="login_title">重置密码</p>
        <div class="login-icon">
            <img src="../../assets/images/login/login-icon.png" alt="">
        </div>
        <van-cell-group>
            <van-field
            v-model="phone"
            placeholder="请输入手机号"
            >
            <van-icon slot="left-icon" class-prefix="iconfont" name="iconshouji" />
            </van-field>

            <van-field
            v-model="password"
            type="password"
            placeholder="请输入密码"
            >
            <van-icon slot="left-icon" class-prefix="iconfont" name="iconmima" />
            </van-field>

            <van-field
            v-model="password_confirmation	"
            type="password"
            placeholder="请确认密码"
            >
            <van-icon slot="left-icon" class-prefix="iconfont" name="iconmima" />
            </van-field>

            <van-field
            v-model="verify_code"
            center
            placeholder="请输入验证码"
            >
          <van-icon slot="left-icon" class-prefix="iconfont" name="iconanquan1" />
          <van-button slot="right-icon" class="getCaptcha" type="info" size="small" @click="getSMSVerifyCode" :class="{'disabled-style':getCodeBtnDisable}" :disabled="getCodeBtnDisable">{{codeBtnWord}}</van-button>
        </van-field>
      </van-cell-group>
      <div class="btns">
        <div class="btn-login" @click="resetPassword">重置密码</div>
        <div class="btn-login" @click="$router.go(-1)">返回</div>
      </div>
      </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  name: 'forgetPwd',
  data(){
    return {
      phone: '', // 手机号 
      password: '', // 密码
      password_confirmation: '', // 确认密码
      verify_code: '', // 验证码
      logo: '', // 默认logo
      title: '',
      getCodeBtnDisable: false,
      codeBtnWord: '获取验证码', // 获取验证码按钮文字
      waitTime: 61 // 获取验证码按钮失效时间
    }
  },
  mounted(){},
  components: {
    getCodeBtnDisable: {
      get () {
        if (this.waitTime === 61) {
          return true
        }
        return true
      },
      set () {}
    }
  },
  methods: {
    // 获取短信验证码
    getSMSVerifyCode () {
      if (this.phone === '') {
        Toast('请填写手机号')
      } else {
        let data = {
          phone: this.phone
        }
        this.util.get(this.api.getSMSVerifyCode, data, (success) => {
          Toast('验证码已发送，请稍候...')
          let that = this
          that.waitTime--
          that.getCodeBtnDisable = true
          this.codeBtnWord = `${this.waitTime}s 后重新获取`
          let timer = setInterval(function () {
            if (that.waitTime > 1) {
              that.waitTime--
              that.codeBtnWord = `${that.waitTime}s 后重新获取`
            } else {
              clearInterval(timer)
              that.codeBtnWord = '获取验证码'
              that.getCodeBtnDisable = false
              that.waitTime = 61
            }
          }, 1000)
          })
      }
    },
    // 重置密码
    resetPassword () {
      let data = new FormData()
      data.append('phone', this.phone)
      data.append('password', this.password)
      data.append('password_confirmation', this.password_confirmation)
      data.append('verify_code', this.verify_code)
      this.util.post(this.api.resetPassword, data, (success) => {
        Toast('重置密码成功')
        this.$router.push('/login')
      })
    }
  }
}
</script>
<style lang='scss'>
@import "../../assets/scss/functions";
.forgetPwd {
  width: 100%;
  height: 100%;
  background: url("../../assets/images/login/login-bg.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;

  .login_box {
    width: pxToRem(500px);
    position: absolute;
    /*top: 50%;*/
    top: 8%;
    left: 50%;
    /*margin-top: pxToRem(-500px);*/
    margin-left: pxToRem(-250px);

    .login_logo_box {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: pxToRem(100px);

      .logo {
        width: pxToRem(90px);
        margin-right: pxToRem(30px);
      }

      .title {
        color: #fff;
        font-size: pxToRem(35px);
        letter-spacing: 2px;
        font-weight: 500;
      }
    }

    .login_title {
      text-align: center;
      font-size: pxToRem(45px);
      letter-spacing: 1px;
      color: #fff;
      margin-bottom: pxToRem(30px);
      font-weight: 500;
    }

    .login-icon {
      text-align: center;
      margin-bottom: pxToRem(40px);

      img {
        width: pxToRem(48px);
      }
    }

    .icon-code {
      width: 0.67rem;
    }

    .btns {
      width: 100%;
      overflow: hidden;
      display: flex;
      justify-content: space-between;
      margin-top: pxToRem(40px);
    }

    .btn-login {
      width: 40%;
      padding: pxToRem(15px) pxToRem(20px);
      background:linear-gradient(-90deg,rgba(31,112,163,1),rgba(31,88,146,1));
      box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.25);
      border-radius: pxToRem(50px);
      text-align: center;
      color: #fff;
      letter-spacing: 2px;
      font-size: pxToRem(30px);
      font-weight: 500;
    }

    .van-cell-group, .van-cell, .van-field__control {
      background-color: transparent;
      color: #fff;
    }

    .van-field__control::-webkit-input-placeholder {
      color: #fff;
      font-size: pxToRem(20px);
    }

    .iconfont {
      font-size: pxToRem(50px);
      vertical-align: middle;
    }

    .van-cell {
      background:rgba(0, 0, 0, 0.3);
      margin-bottom: pxToRem(60px);
      border: pxToRem(1px) solid rgba(255, 255, 255, 1);
      border-radius: pxToRem(50px);
      padding: pxToRem(10px) pxToRem(20px);
      line-height: inherit;
    }
    .van-cell:last-of-type {
      margin-bottom: pxToRem(10px);
    }
    
    .getCaptcha {
      float: right;
      // margin: pxToRem(10px) pxToRem(20px) pxToRem(10px) 0;
      height: pxToRem(55px);
      background-color: #2f7acf;
      border-color: #2f7acf;
    }

    .van-cell:not(:last-child)::after {
      border-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/forgetPwd.vue